import { QueryKey, UseQueryOptions } from 'react-query';
import { Title } from '../../titles/types/title';
import { fetchBookmarks, fetchContinueWatchingTitles } from './api';
import { bookmarksKey, continueWatchingTitlesKey } from './keys';
import { Bookmark } from './types';

export function bookmarksQuery<T = Bookmark[]>(options?: UseQueryOptions<Bookmark[], unknown, T, QueryKey>) {
  return {
    queryKey: bookmarksKey(),
    queryFn: () => fetchBookmarks(),
    retry: 1,
    useErrorBoundary: true,
    ...options,
  } as const;
}

export function continueWatchingTitlesQuery<T = Title[]>(options?: UseQueryOptions<Title[], unknown, T, QueryKey>) {
  return {
    queryKey: continueWatchingTitlesKey(),
    queryFn: () => fetchContinueWatchingTitles(),
    useErrorBoundary: true,
    ...options,
  } as const;
}
